export default function SVGFlag({ opacity }) {
  return (
    <g style={{ willChange: 'opacity' }} opacity={opacity}>
      <g id="Flag-2-2" data-name="Flag-2">
        <path
          d="M448.14,2792.73c-51.16-30.54-130.09-7.41-185.75-25.65-7.93-2.64-19-16-27.1-11.11-1.46,4.9-4.63,22-4,22.74,62.27,70.6,173.46-1.19,214.31,46a2.28,2.28,0,0,0,2,.66C464.94,2830.14,453.3,2795.77,448.14,2792.73Z"
          fill="#f2f2f2"
        />
        <path
          d="M458.59,2797.09c.79-2.11,1.72-4.36,2.64-6.48,2.65-7.14,5.69-14,10.71-19.56a12.25,12.25,0,0,0,1.46-2.12c-4.9-5.68-12.83-9.65-19.7-12.69-32.26-14.68-68.22-13-102.6-11.9-18.24.53-36.62,2.12-54.86.53-14.28-1.32-41.38-16.66-54.34-13-3.17,7.27-6.35,15.6-5.82,22.48a1.78,1.78,0,0,0,.27.79,2.29,2.29,0,0,0-.93,3,3.58,3.58,0,0,0,.66.8c26.71,21.28,63.2,27.1,97.18,28,39.92,1.06,73.9-11.5,111.18,10.84,3,1.86,6.35,4.5,9.92,6.22C455.81,2800.93,457.13,2800,458.59,2797.09Z"
          fill="#f9f9f9"
        />
        <path
          d="M462.69,2735.61c-57.91-33.71-134.72,1.06-192.5-25-20.62-9.26-27.23-.93-30.14,22.61-.53.79,2.51,2.51,3.3,3,32,23.93,69.41,32.12,108.81,30.14,34.64-1.72,80.12-13,107.75,16.26,1.59,1.72,3.84.27,4.1-1.59a2,2,0,0,0,1.45-1.05C474.72,2766.29,480.4,2745.93,462.69,2735.61Z"
          fill="#f3f3f3"
        />
        <path
          d="M473.26,2721.47c-46.27-28-95.71-19-146.48-17.85-29.62.66-63.2-29.48-76.68-15.34-1.72,5.95-7,23.67-4,23.67,37.15,27.76,82,35,126.52,30.94,26.18-2.38,91-3.44,100.35,22.6C482.25,2751,492.3,2732.84,473.26,2721.47Z"
          fill="#ededed"
        />
        <path
          d="M509.49,2914.1c-6.21-14.81-58.57-16-73.38-23.54-7.4-3.7-56.58-41.38-56.71-41.11-30.54,47.86,42.7,77.47,71.92,83.55C464,2935.65,523.24,2946.49,509.49,2914.1Z"
          fill="#fafafa"
        />
        <path
          d="M507.77,2873.38c-15.2-6-33-7.8-49.18-9.92-8.2-1.06-16.66-1.72-24.59-4.49a35.64,35.64,0,0,1-7.14-3.31c-.4.93-19.57,5.55-34.24-2.78v.14c-2-.4-.14,27.1,43.49,43.62,22.48,8.47,46.94,13,70.74,15.21h.52a2,2,0,0,0,2.65-1.06h0a1.21,1.21,0,0,0,.13-.66C509.36,2899.42,519.54,2877.87,507.77,2873.38Z"
          fill="#f1f1f1"
        />
        <path
          d="M520.59,2836.62c-24.59,9.79-51-5.95-76.28-7.27-2.64-.13-3.3,12.43-6.21,13.75.53,4.36-1.33,8.86-6.61,9.78h-.93a9.94,9.94,0,0,1-6.74,3.71c27.37,12.69,57.51,20.88,89.77,19.69.26-.92.39-1.85.66-2.77,1.59-8.73,3.3-17.32,7.8-25,.13-.13.26-.26.26-.4l.14-.53c.13-.26.26-.66.52-.79l1.33-8.59C524.83,2836.75,522.18,2836,520.59,2836.62Z"
          fill="#f9f9f9"
        />
        <path
          d="M530.91,2805.55a80.81,80.81,0,0,1-59.36,2.51c-5.95-5.68-12.3-7.13-19.31-4.36-3.83,8.86-11.63,29.22-9.52,29.62,26.58,5.42,49.85,15.07,78.4,5.81a3.29,3.29,0,0,1,1.59,0,297.41,297.41,0,0,0,12-31.2C535.27,2806.08,532.89,2804.63,530.91,2805.55Z"
          fill="#f3f3f3"
        />
        <path
          d="M482.12,2704.81c-27-13.22-75.22-5.55-101.14-4.76-41.51,2.78-86.46,3.7-122.16-21.42-1.19-.66-7-4.89-8.72,9.52,59.89,67.43,170-6.74,231.63,56.19a2.51,2.51,0,0,0,3.57-.13A2.76,2.76,0,0,0,486,2742C492,2730.46,494.55,2712.61,482.12,2704.81Z"
          fill="#f8f8f8"
        />
        <path
          d="M537.25,2798.68a107.93,107.93,0,0,1,7.67-11.5c1.06-3,1.06-6.09-3.44-7.14-3.3-.8-7.14-.66-10.57-.8l-45.09-2.77c-7.8-.53-15.73-1.85-20.36,3.43-4.62,7.41-12.95,25.65-11.23,26.31a144.45,144.45,0,0,0,64.91,7.8c4.76-.52,9.52-1.19,13.35-3A33.44,33.44,0,0,1,537.25,2798.68Z"
          fill="#ededed"
        />
        <path
          d="M547,2754.12c-13.49-1.32-51.3,4-65.18-5.28-4.63,6.21-10.18,20.62-14.41,27-1.32.52-3.31,4-1.85,2.9,20.89,6.35,45.87,10.32,67.69,6.61,6.34-1.05,13-3.3,15.73-7.53C551.27,2770,563,2755.84,547,2754.12Z"
          fill="#f8f8f8"
        />
        <path
          d="M487.68,2754c-1.86-3.44-6.35-4-9.52-2-2.52,12.56-9.52,24.85-16.79,35.43-7.67,17.72-11.24,39.4-22.88,54.73,5.42,14-35.56,24.07-53.81,6.61-.13-.13-.39-.13-.52-.26h-.4c-14.54,1.19-14.28,38.34-4.76,46,4.23-11.24,6.08-15.73,12.16-19.7a32.6,32.6,0,0,1,26.18-4.23c18.91,4.89,39.79,13.48,44.16-41.51C462.82,2811.9,483.31,2752.93,487.68,2754Z"
          fill="#ececec"
          opacity="0.69"
        />
        <path
          d="M439.82,2844.55c-1.46-18.37-35.17-11.37-35.83-14,1.32,5.29,12.56,1.06,10.57,11.11-2.64,9.38-36.49,5.55-29.74,7l.66.13a2.23,2.23,0,0,0,1.19,2.65,49.85,49.85,0,0,0,31.2,7C425,2857.51,440.61,2854.6,439.82,2844.55Z"
          fill="#ececec"
          opacity="0.69"
        />
        <path
          d="M489.53,2715.52c-3-10.31-14.15-16.79-24.73-16.53-1.32,0-13.22.53-18.77,0-61.08-6.87-136.31,21.82-188.53-22.74-2.38-2.11-5.95,1.46-3.57,3.57,48.65,41.52,115,21,172.27,22.87,91.35,3,22.08,81,9.52,132.08.39-1.72,3.7,8.07,5,5.42C443.78,2805.55,497.46,2742.49,489.53,2715.52Z"
          fill="#fff"
          opacity="0.46"
        />
        <path
          d="M458.72,2740.51c-3.7,9.12-7.53,18.11-11.77,27.1-1.32,2.91,3.18,5,4.5,2.11,4.23-8.85,8.2-18,11.77-27.1C464.54,2739.58,459.91,2737.47,458.72,2740.51Z"
          fill="#fff"
        />
        <path d="M445.5,2775.94a2.51,2.51,0,0,0-2,2.91A2.66,2.66,0,0,0,446,2781a2.54,2.54,0,0,0-.53-5Z" fill="#fff" />
        <path
          d="M553.25,2756.64a2.51,2.51,0,0,0-2,1.05,7,7,0,0,0-3-2.51c-3.18-1.19-7.14-.79-10.45-.92l-13.75-.53c-3.44-.13-38.21.92-29.08,1.19l26.7,3.57a29.48,29.48,0,0,0,4.76.39l13.36.4c2.9.13,4.62-.53,6.21,1.85,3.57,7-67.82,146.36-35.57,170.29-9.12-50.38,39.8-155.22,41.65-168.57a2.51,2.51,0,0,0,1.06.26,2.6,2.6,0,0,0,2.51-2.51v-1.32a2.37,2.37,0,0,0-2.38-2.64Z"
          fill="#fff"
          opacity="0.62"
        />
      </g>
      <g id="Layer_15" data-name="Layer 15">
        <path
          d="M227.89,2795.51c13.48-81.84,38.86-159.32,27.63-158.79-11,.53-25.12,72.59-29.09,136.31a52.52,52.52,0,0,0,36.23,53c29.08,9.38,53.94,7.66,95.19,6.08,57.51-2.25,81.83-5.69,81.83,14.14,0,9.13-32.12,22.08-56.71.8-15.21-13,5.55-20,3.7-9.39s-27.77,16-8.07,55c17.72,35.3,88.71,47.86,123.49,45.08a9.79,9.79,0,0,0,9-10.57h0v-.27c-6.22-64,37.28-150.85,43-162.48,6-12.17-9.25-10.71-34.63-9.79s-39.54-2.51-35.83-8.85c-7,13.22-42.44,75.35-42.18,96.51.66,3.83,6.22,4.1,6.22-4.1,0-46.8,52.35-100.88,42-124.54-10.58-24.33-53.68-12.56-161.16-13.09-36.1-.26-60.69-14-77.48-32.52"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </g>
  );
}

export function MobileSVGFlag({ opacity }) {
  return (
    <g style={{ willChange: 'opacity' }} opacity={opacity}>
      <g id="Flag-2-2-2" data-name="Flag-2-2">
        <path
          d="M408.3,1722.4c-22.5-13.4-57.2-3.3-81.7-11.3-3.5-1.2-8.3-7-12-4.9-.6,2.2-2.1,9.6-1.7,10,27.4,31,76.3-.5,94.3,20.3a1.4,1.4,0,0,0,.9.3C415.7,1738.9,410.6,1723.7,408.3,1722.4Z"
          fill="#f2f2f2"
        />
        <path
          d="M412.9,1724.3c.4-.9.8-1.9,1.2-2.8,1.2-3.1,2.5-6.2,4.7-8.6a5.57,5.57,0,0,1,.7-.9c-2.1-2.5-5.6-4.2-8.7-5.6-14.2-6.5-30-5.7-45.2-5.2-8,.3-16.1.9-24.1.2-6.3-.6-18.2-7.3-23.9-5.7-1.4,3.2-2.8,6.8-2.6,9.9a.79.79,0,0,0,.1.4.88.88,0,0,0-.48,1.15,1.09,1.09,0,0,0,.08.15l.3.3c11.7,9.3,27.8,11.9,42.8,12.3,17.6.4,32.5-5.1,48.9,4.8a37.3,37.3,0,0,0,4.4,2.7C411.7,1726,412.3,1725.6,412.9,1724.3Z"
          fill="#f9f9f9"
        />
        <path
          d="M414.8,1697.3c-25.5-14.8-59.2.4-84.7-11-9.1-4.1-12-.4-13.2,9.9-.2.4,1.1,1.1,1.5,1.3,14.1,10.5,30.5,14.1,47.8,13.3,15.3-.8,35.3-5.7,47.4,7.1a1.07,1.07,0,0,0,1.51-.05,1.05,1.05,0,0,0,.29-.65,1.64,1.64,0,0,0,.7-.4C420.1,1710.7,422.6,1701.8,414.8,1697.3Z"
          fill="#f3f3f3"
        />
        <path
          d="M419.4,1691c-20.4-12.3-42.1-8.4-64.4-7.8-13,.3-27.8-13-33.7-6.8-.8,2.6-3.1,10.4-1.7,10.4,16.3,12.2,36.1,15.4,55.7,13.6,11.5-1.1,40-1.5,44.1,10C423.4,1704,427.8,1696.1,419.4,1691Z"
          fill="#ededed"
        />
        <path
          d="M435.4,1775.8c-2.8-6.5-25.7-7-32.3-10.3-3.3-1.6-24.9-18.2-24.9-18.1-13.4,21.1,18.8,34.1,31.6,36.8C415.4,1785.3,441.4,1790,435.4,1775.8Z"
          fill="#fafafa"
        />
        <path
          d="M434.6,1757.9c-6.7-2.6-14.5-3.4-21.6-4.3a49,49,0,0,1-10.8-2,14.78,14.78,0,0,1-3.1-1.5c-.2.4-8.6,2.4-15.1-1.2v.1c-.8-.2,0,11.9,19.1,19.2a122.25,122.25,0,0,0,31.1,6.7h.3a.9.9,0,0,0,1.19-.48v0h0c0-.1.1-.2.1-.3C435.3,1769.3,439.8,1759.9,434.6,1757.9Z"
          fill="#f1f1f1"
        />
        <path
          d="M440.2,1741.7c-10.8,4.3-22.5-2.6-33.6-3.2-1.2-.1-1.5,5.4-2.7,6.1.2,1.9-.6,3.9-2.9,4.3h-.4a4.28,4.28,0,0,1-3,1.6c12,5.6,25.3,9.2,39.5,8.7l.3-1.2c.7-3.8,1.4-7.6,3.4-11,0-.1.1-.1.1-.2l.1-.2c.1-.1.1-.3.2-.4l.6-3.8C442.1,1741.8,440.9,1741.4,440.2,1741.7Z"
          fill="#f9f9f9"
        />
        <path
          d="M444.8,1728a35.23,35.23,0,0,1-26.1,1.1c-2.6-2.5-5.4-3.1-8.5-1.9-1.7,3.9-5.1,12.9-4.2,13,11.7,2.4,21.9,6.7,34.5,2.6a.85.85,0,0,1,.7,0,143,143,0,0,0,5.3-13.7C446.7,1728.3,445.6,1727.6,444.8,1728Z"
          fill="#f3f3f3"
        />
        <path
          d="M423.3,1683.8c-11.9-5.8-33.1-2.4-44.5-2.1-18.3,1.2-38,1.6-53.8-9.4-.5-.3-3.1-2.1-3.9,4.2,26.3,29.7,74.8-3,101.9,24.7a1.09,1.09,0,0,0,1.5,0,1.68,1.68,0,0,0,.3-1C427.7,1695,428.8,1687.2,423.3,1683.8Z"
          fill="#f8f8f8"
        />
        <path
          d="M447.6,1725a33.87,33.87,0,0,1,3.4-5c.4-1.3.5-2.6-1.5-3.1a35.34,35.34,0,0,0-4.7-.4l-19.9-1.2c-3.4-.2-6.9-.8-9,1.5-2.1,3.3-5.7,11.3-5,11.5a63.08,63.08,0,0,0,28.6,3.4,18.1,18.1,0,0,0,5.9-1.3A15.82,15.82,0,0,1,447.6,1725Z"
          fill="#ededed"
        />
        <path
          d="M451.9,1705.4c-5.9-.6-22.6,1.7-28.7-2.3-2,2.7-4.5,9.1-6.4,11.9-.6.2-1.5,1.7-.8,1.3,9.2,2.8,20.2,4.5,29.8,2.9,2.8-.5,5.7-1.5,6.9-3.3C453.8,1712.4,458.9,1706.2,451.9,1705.4Z"
          fill="#f8f8f8"
        />
        <path
          d="M425.7,1705.4a2.93,2.93,0,0,0-4-.91l-.16.11c-1.1,5.5-4.2,10.9-7.4,15.6-3.4,7.8-4.9,17.3-10,24.1,2.4,6.2-15.6,10.6-23.7,2.9a.35.35,0,0,1-.2-.1H380c-6.4.5-6.3,16.9-2.1,20.2,1.9-5,2.7-6.9,5.3-8.7a14.15,14.15,0,0,1,11.5-1.8c8.3,2.2,17.5,5.9,19.5-18.2C414.8,1730.9,423.8,1704.9,425.7,1705.4Z"
          fill="#ececec"
          opacity="0.69"
          style={{ isolation: 'isolate' }}
        />
        <path
          d="M404.7,1745.2c-.7-8.1-15.5-5-15.8-6.2.6,2.3,5.6.5,4.7,4.9-1.2,4.2-16.1,2.5-13.1,3.1l.3.1a1.15,1.15,0,0,0,.5,1.2,22,22,0,0,0,13.7,3.1C398.2,1750.9,405,1749.6,404.7,1745.2Z"
          fill="#ececec"
          opacity="0.69"
          style={{ isolation: 'isolate' }}
        />
        <path
          d="M426.6,1688.5c-1.4-4.5-6.2-7.4-10.9-7.3-.6,0-5.8.2-8.3,0-26.9-3-60,9.6-82.9-10-1.1-.9-2.6.6-1.6,1.6,21.4,18.3,50.6,9.2,75.8,10.1,40.2,1.3,9.7,35.6,4.2,58.1.2-.7,1.6,3.5,2.2,2.4C406.4,1728,430.1,1700.3,426.6,1688.5Z"
          fill="#fff"
          opacity="0.46"
          style={{ isolation: 'isolate' }}
        />
        <path
          d="M413,1699.4c-1.6,4-3.3,8-5.2,11.9a1.1,1.1,0,0,0,2,.9c1.8-3.9,3.6-7.9,5.2-11.9a1.1,1.1,0,0,0-2-.9Z"
          fill="#fff"
        />
        <path
          d="M407.2,1715a1.14,1.14,0,0,0-.9,1.3,1.17,1.17,0,0,0,1.1.9,1.14,1.14,0,0,0,.9-1.3A1.17,1.17,0,0,0,407.2,1715Z"
          fill="#fff"
        />
        <path
          d="M454.6,1706.5a1.23,1.23,0,0,0-.8.4,2.59,2.59,0,0,0-1.4-1.1,14.26,14.26,0,0,0-4.6-.4l-6.1-.2c-1.5-.1-16.8.4-12.8.5l11.8,1.6a14.78,14.78,0,0,0,2.1.2l5.9.2c1.3,0,2-.3,2.8.8,1.6,3.1-29.8,64.4-15.6,74.9-4-22.2,17.5-68.3,18.3-74.2a.58.58,0,0,0,.4.1,1.11,1.11,0,0,0,1.1-1.1v-.6a1.18,1.18,0,0,0-1.1-1.1Z"
          fill="#fff"
          opacity="0.62"
          style={{ isolation: 'isolate' }}
        />
      </g>
      <g id="Layer_15" data-name="Layer 15">
        <path
          d="M311.4,1723.6c6-36,17.1-70.1,12.2-69.9s-11.1,31.9-12.8,60a23,23,0,0,0,15.9,23.3c12.8,4.1,23.7,3.4,41.9,2.7,25.3-1,36-2.5,36,6.2,0,4-14.1,9.7-25,.4-6.7-5.7,2.5-8.8,1.6-4.1s-12.2,7-3.6,24.2c7.8,15.5,39,21.1,54.3,19.8a4.34,4.34,0,0,0,4-4.6h0v-.1c-2.7-28.1,16.4-66.4,18.9-71.5,2.6-5.4-4.1-4.7-15.2-4.3s-17.4-1.1-15.8-3.9c-3.1,5.8-18.7,33.2-18.5,42.5.3,1.7,2.7,1.8,2.7-1.8,0-20.6,23-44.4,18.5-54.8-4.7-10.7-23.6-5.5-70.9-5.8-15.9-.1-26.7-6.2-34.1-14.3"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  );
}
